import slideTypeModule from './slideType.module'
import slideInsertionToPresentationModule from './slideInsertionToPresentation.module'
import slideRenderHandlerModule from './slide-render-handler.module'
import slideTypeListModule from './slideTypeList.module'
import slideModule from './slide.module'
import slideContentSyncModule from './slide-content-sync.module'
import slideSettingModule from './slide.setting.module'
import openEndedModule from './openEnded.module'
import contentV2ConvertModule from './contentV2Convert.module'

export default {
  slideType: slideTypeModule,
  slideInsertionToPresentation: slideInsertionToPresentationModule,
  slideRenderHandler: slideRenderHandlerModule,
  slideTypeList: slideTypeListModule,
  slideModule,
  slideContentSync: slideContentSyncModule,
  slideSettingModule,
  openEndedModule,
  contentV2Convert: contentV2ConvertModule,
}
